import {BaseModelService} from './BaseModelService';
import {Event} from '../Models';
import {SessionStorageObject} from '../Utilities/SessionStorageObject';

export class EventService extends BaseModelService<Event> {
  constructor(apiUrl: string = '') {
    super(Event);
    this.apiBaseUrl = `${apiUrl}/v1/inventory/public/events`;
  }

  public async list(path: string = '', filters: {} = {}): Promise<Array<Event>> {
    return super.list(path, {...filters, source: 1});
  }

  async listCached<U extends SessionStorageObject>(path = '', filters = {}): Promise<U[]> {
    return super.listCached<U>(path, {...filters, source: 1});
  }
}
